export {
  InjectionMode,
  Stylesheet,
  concatStyleSets,
  concatStyleSetsWithProps,
  fontFace,
  keyframes,
  mergeStyleSets,
  mergeStyles,
} from '@fluentui/merge-styles';
export type {
  IFontFace,
  IFontWeight,
  IRawStyle,
  IStyle,
  IStyleSet,
  IStyleSetBase,
  IProcessedStyleSet,
  IStyleSheetConfig,
  ICSPSettings,
  ShadowConfig,
} from '@fluentui/merge-styles';
